import { useEffect, useState } from 'react';
import { MODES, storedMode, setMode, resolve, watchSystem } from './theme.js';

const NEXT = { system: 'light', light: 'dark', dark: 'system' };
const LABEL = { system: 'Theme: following your system', light: 'Theme: light', dark: 'Theme: dark' };

const Sun = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
  </svg>
);
const Moon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />
  </svg>
);
const Auto = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    {/* half filled — the icon says "it depends", which is what system mode means */}
    <path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none" />
  </svg>
);

export function ThemeToggle() {
  const [mode, setLocal] = useState(storedMode);
  const [theme, setTheme] = useState(() => resolve(storedMode()));

  // While on "system", follow the machine live — no reload, no second click.
  useEffect(() => watchSystem(setTheme), []);

  function cycle() {
    const next = NEXT[mode] ?? 'system';
    setLocal(next);
    setTheme(setMode(next));
  }

  const Icon = mode === 'system' ? Auto : theme === 'dark' ? Moon : Sun;

  return (
    <button className="themebtn" onClick={cycle} title={LABEL[mode]} aria-label={LABEL[mode]}>
      <Icon />
    </button>
  );
}

export { MODES };
